<template>
  <div class="course-sign">
    <el-dialog
      v-model="centerDialogVisible"
      append-to-body
      :title="signType == 3?'人脸识别认证': '打卡认证'"
      :width="signType == 2 ? '500px' : '736px'"
      custom-class="course-sign-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      top="16vh"
      center
    >
      <div
        v-loading="loading"
        class="video-box"
      >
        <div
          v-show="signType == 2"
          class="box"
        >
          <div
            class="circle-btn"
            @click="clickSign"
          >
            <span class="font20">立即打卡</span>
            <span class="click-time">{{ nowTime }}</span>
          </div>
          <p class="click-tip c_999">
            本课程将不定时弹出打卡以防止挂机，打完卡可继续学习
          </p>
        </div>
        <div
          v-show="signType == 3"
          class="sign-video"
        >
          <div
            class="plot"
            :style="plot"
          />
          <video
            id="FaceIdVideo"
            :style="{opacity: signStatus == 1? 1 : 0}"
            src=""
          />
          <img
            v-if="isUnion"
            src="@/assets/Union.svg"
            class="union"
            alt=""
          >
          <div
            v-if="countdown > 0 "
            class="countdown"
          >
            剩余：{{ countdown }}秒
          </div>
        </div>
        <div
          v-if="signType == 3"
          class="sign-tip"
          style="margin-top: 10px;"
        >
          1.请先核对您的真实姓名、身份证号信息是否正确可使用；
        </div>
        <div
          v-if="signType == 3"
          class="sign-tip"
        >
          2.确认是否有摄像头或者是否已同意授权网站使用摄像头？若无法使用，请登录小程序或者APP进行人脸识别；
        </div>
        <div
          v-if="signType == 3 && signData.enabledFaceError == 1"
          class="signuserFaceId-tip"
        >
          3.人脸识别剩余打卡次数 <span class="red">{{ signData.faceErrorCount - signData.signFailNum }}</span> 次，当前已失败 <span class="red">{{ signData.signFailNum }}</span> 次，超出将不可继续进行考试或学习课程，请知晓！
        </div>
        <div
          v-if="signType == 3"
          class="btn-list"
        >
          <el-button
            class="btn"
            :disabled="signStatus !=0 && signStatus != 3"
            @click="hideSign()"
          >
            关闭验证
          </el-button>
          <el-button
            type="primary"
            class=" max-btn"
            @click="startSgin()"
          >
            {{ startBtnText }}
          </el-button>
          <el-button
            class="btn"
            :disabled="startBtnText === '正在验证中，请勿离开此页...'"
            @click="toUserInfo()"
          >
            核对身份
          </el-button>
        </div>

        <div
          v-if="isShowResetTip"
          class="reset-box"
        >
          <i class="iconfont icon-cuowu" />
          <p class="reset-title">
            验证失败
          </p>
          <p class="reset-tip">
            {{ resetTip }}
          </p>
        </div>

        <div
          v-if="isWin"
          :class="['win-box',signType == 2 ? 'win-box-click' : '']"
        >
          <i class="iconfont icon-success" />
          <p class="win-title">
            {{ signType == 3 ? '验证成功!' : '打卡成功!' }}
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { userFaceId, getUserFaceIdConfig } from '@/api/course.js'
import { ElMessageBox, ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/user'
import { parseTime } from '@/utils/index.js'

export default {
  name: 'CourseSign',
  props: {
    player: {
      type: Object,
      default () {
        return null
      }
    },
    bizType: {
      type: Number,
      default () {
        return 2
      }
    },
    courseInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    const that = this
    return {
      nowTime: '',
      trackerTask: null,
      first: null,
      loading: false,
      signType: 3,
      centerDialogVisible: false,
      idCardvisible: false,
      signStatus: 0, // 0 未开始认证 1认证中 2 认证成功3 认证失败
      chunks: [],
      tip: '正在录像！请不要转头或者把头移出摄像头里',
      videoStream: null,
      countdown: -1,
      startBtnText: '开始认证',
      signData: {},
      plot: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        opacity: 0
      },
      resetTip: '请确定身份证号码和姓名是否正确？',
      isShowResetTip: false,
      isWin: false,
      isUnion: false,
      playerBox: {
        paused: false,
        pause () {
          this.paused = true
          if (!that.player) return
          that.player.pause()
        },
        resume () {
          this.paused = false
          if (!that.player) return
          that.player.play()
        },
        getCurrentTime () {
          if (!that.player) return
          return that.player.getCurrentTime()
        },
        getDuration () {
          if (!that.player) return
          return that.player.getDuration()
        },
        exitFullScreen () {
          if (this.player.exitFullScreen) {
            that.player.exitFullScreen()
          }
        }
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo || {}
    }
  },
  watch: {
    player (player) {
      this.initSign()
      const This = this
      if (player && player.on) {
        try {
          // // 西瓜播放器 百家云播放器
          // player.on('pause', function (e) {
          //   This.playerBox.paused = true
          // })
          // player.on('play', function (e) {
          //   This.playerBox.paused = false
          // })
        } catch (e) {}
      }
    }
  },
  mounted () {
    this.nowTime = parseTime(new Date()).slice(11)
  },
  unmounted () {
    ElMessageBox.close()
    clearInterval(this.timer)
    clearInterval(this.FaceTimer)
    clearInterval(this.contrastTime)
    try {
      if (this.localStream) {
      // 关闭摄像头
        this.localStream.getTracks().forEach((track) => {
          track.stop()
        })
      }
      if (this.trackerTask) {
        // 停止侦测
        this.trackerTask.stop()
      }
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    hideSign () {
      this.centerDialogVisible = false
    },
    toUserInfo () {
      this.$router.push({
        path: '/account/info'
      })
    },
    init () {
      return new Promise((resolve, reject) => {
        const That = this
        const d = {
          bizType: this.bizType,
          courseId: this.courseInfo.id
        }
        if (this.courseInfo.chapterId) {
          d.chapterId = this.courseInfo.chapterId
        }
        if (this.courseInfo.periodId) {
          d.periodId = this.courseInfo.periodId
        }
        if (this.courseInfo.paperId && (this.bizType === 1 || this.bizType === 3)) {
          delete d.courseId
          d.paperId = this.courseInfo.paperId
        } else if (this.courseInfo.classroomExamId && this.bizType === 5) {
          delete d.courseId
          d.classroomExamId = this.courseInfo.classroomExamId
        }
        getUserFaceIdConfig(d).then(res => {
          if (res && (res.checkType > 1 || res.faceRecognition)) {
            if (res.enabledFaceError && res.faceErrorCount <= res.signFailNum) {
              return ElMessageBox.alert('今日人脸识别错误次数已经超出限制了，无法' + (this.bizType == 1 || this.bizType == 3 ? '考试' : '学当前课程！'), '提示', {
                confirmButtonText: '返回上一页',
                showClose: false,
                callback: () => {
                  reject('')
                  That.$router.go(-1)
                }
              })
            }

            if ((res.checkType === 3 || res.faceRecognition) && res.checkCount > 0 && res.remainingCheckCount > 0) {
              if (res.certification) {
                let tip = '当前课程需要人脸认证，请先补全身份证号和姓名再来，' + (this.bizType == 1 ? '考试' : '学当前课程！')
                if (this.bizType == 3 || this.bizType == 5) {
                  tip = '当前考试需要人脸认证，请先补全身份证号和姓名再来考试'
                }
                ElMessageBox.alert(tip, '提示', {
                  confirmButtonText: '去修改身份信息',
                  showClose: false,
                  callback: () => {
                    reject('')
                    That.toUserInfo()
                  }
                })
                return
              }
            }

            this.signType = res.checkType
            this.signData = res

            if (this.bizType == 2) {
              // 多次人脸打卡 或 点击打卡流程
              this.constrastTimes = ''
              this.initSign()
              resolve()
            } else if (res.faceRecognition && res.remainingCheckCount > 0) {
              // 单次人脸认证
              this.signType = 3
              this.sign(5)
              this.startSgin()
              this.signWinCallBack = resolve
            } else {
              resolve()
            }
          } else {
            // 不用打卡 直接播放视频
            resolve()
          }
        })
      })
    },
    initSign () {
      if (!this.player) return
      if (this.bizType === 1) return
      if (!this.signData.checkCount) return
      this.contrastTime = setInterval(() => {
        // 获取总播放时长
        const duration = this.playerBox.getDuration()
        if (!duration) return
        // 播放器暂停就不执行判断
        if (this.playerBox.paused) return
        // 根据总时长和打卡次数生成打卡时间点
        if (!this.constrastTimes) {
          const startTime = 0
          const d = (duration - startTime) / (this.signData.checkCount + 1)
          let randomNum = 0

          if (d > 300) {
            // 如果总时长大于5分钟 就用平均打卡时长 / 10 再乘随机数 为随机打卡时间点
            randomNum = parseInt(d / 10)
          }
          const times = [] // 把时间平分 然后每段加上 平分时间 / 2  * 0 - 1随机数
          for (let i = 1; i < (this.signData.checkCount + 1); i++) {
            const randomTime = startTime + d * i + (randomNum * Math.random())
            times.push(randomTime)
          }
          // 删除已经打卡了时间点
          times.splice(0, this.signData.checkCount - this.signData.remainingCheckCount)
          this.constrastTimes = times
        }
        const currentContrastTime = this.constrastTimes[0] // 获得当前认证时间点
        const currentTime = this.playerBox.getCurrentTime()
        if (currentTime >= currentContrastTime && !this.centerDialogVisible) {
          this.playerBox.pause() // 暂停播放
          this.sign(5)
        }
      }, 1000)
    },
    sign (number, isStart = false) {
      this.centerDialogVisible = true
      this.loading = false
      this.time = number || 5 // 录像多少秒视频
      this.trackerTask = null // 重置人脸检测对象
      this.isUnion = false
      this.first = '' // 重置是否检测到人脸
      this.isWin = false // 重置是否人脸检测是否通过了
      this.isShowResetTip = false // 隐藏重新检测提示
      this.startBtnText = '开始验证'
      this.signStatus = 0
      this.plot.opacity = 0 // 把检测人框隐藏
      clearInterval(this.timer)
      clearInterval(this.FaceTimer)
    },
    startSgin () {
      if (this.signStatus === 2) { // 成功后关闭页面
        this.close()
      }

      if (this.signData.faceErrorCount <= this.signData.signFailNum) {
        return ElMessage({
          message: '已经超出人脸认证错误次数，无法再验证',
          type: 'warning'
        })
        this.centerDialogVisible = false
      }

      if (this.signStatus === 0) {
        this.$nextTick(() => {
          this.openCamera()
        })
      }

      if (this.signStatus === 3) { // 失败后马上重新验证
        const video = document.getElementById('FaceIdVideo')// 显示摄像头拍摄的内容
        video.src = ''
        this.plot.opacity = 0 // 把检测人框隐藏
        this.signStatus === 1
        this.isUnion = false
        this.trackerTask = null // 重置人脸检测对象
        clearInterval(this.timer)
        clearInterval(this.FaceTimer)
        this.isWin = false // 重置是否人脸检测是否通过了
        this.isShowResetTip = false // 隐藏重新检测提示
        this.$nextTick(() => {
          this.openCamera()
        })
      }
    },
    onStart () { // 识别到人脸就显示人脸绿色方形出来屏幕上
      clearInterval(this.timer)
      clearInterval(this.FaceTimer)
      // 倒计时录像时间
      this.countdown = this.time
      this.tip =
        '正在录像！请不要转头或者把头移出摄像头里'
      this.FaceTimer = setInterval(() => {
        clearInterval(this.timer)
        this.countdown--
        if (this.countdown === -1) {
          this.onStop()
          clearInterval(this.FaceTimer)
        }
      }, 1000)
      this.recorder && this.recorder.start()
    },
    onStop () {
      // 结束录像
      this.plot.opacity = 0
      this.loading = false
      this.first = false
      if (this.trackerTask) {
        // 停止侦测
        this.trackerTask.stop()
      }
      this.tip = '正在上传打卡视频，请不要关闭！'
      this.recorder && this.recorder.stop()
    },
    close () {
      clearInterval(this.timer)
      clearInterval(this.FaceTimer)
      this.isUnion = false
      this.isWin = false
      if (this.centerDialogVisible) {
        this.constrastTimes && this.constrastTimes.shift()
        this.playerBox.resume()
        setTimeout(() => {
          this.centerDialogVisible = false
        }, 100)
      }
      try {
        if (this.localStream) {
          // 关闭摄像头
          this.localStream.getTracks().forEach((track) => {
            track.stop()
          })
        }
        if (this.trackerTask) {
          // 停止侦测
          this.trackerTask.stop()
        }
      } catch (e) {
        console.error(e)
      }
    },
    openWin (id) {
      this.loading = false
      this.isUnion = false
      this.signStatus = 2
      // 验证成功函数
      this.startBtnText = '关闭（3）'
      this.isWin = true
      let num = 2
      const timer = setInterval(() => {
        this.startBtnText = '关闭（' + num + '）'
        num--
        if (num === -1) {
          this.signWinCallBack && this.signWinCallBack()
          clearInterval(timer)
          if (this.bizType == 1 || this.bizType == 3 || this.bizType == 5) {
            this.$emit('succeed')
          }
          this.close()
        }
      }, 1000)
    },
    reset (msg) { // 重新检测函数
      this.signStatus = 3
      this.loading = false
      this.isShowResetTip = true
      this.startBtnText = '重新验证'
      clearInterval(this.timer)
      clearInterval(this.FaceTimer)
      msg = msg || '请确定身份证号码和姓名是否正确？'
      this.resetTip = msg
    },
    async uploadVideo () { // 上传视频函数
      function blobToDataURL (blob, callback) {
        const a = new FileReader()
        a.onload = function (e) {
          callback(e.target.result)
        }
        a.readAsDataURL(blob)
      }
      blobToDataURL(this.videoStream.Blob, (base64) => {
        if (base64) {
          base64 = base64.split('base64,')
          if (base64.length) {
            base64 = base64[1]
          }
        }
        if (this.imageBase64) {
          this.imageBase64 = this.imageBase64.split('base64,')
          if (this.imageBase64.length) {
            this.imageBase64 = this.imageBase64[1]
          }
        }
        this.loading = true

        const d = {
          videoBase64: base64,
          bizType: this.bizType || 2,
          checkType: this.signType || 2,
          courseId: this.courseInfo.id,
          _No_dispose: true
        }

        if (this.courseInfo.chapterId) {
          d.chapterId = this.courseInfo.chapterId
        }

        if (this.courseInfo.periodId) {
          d.periodId = this.courseInfo.periodId
        }
        // if (this.bizType) {
        //   delete d.courseId
        //   d.paperId = this.courseInfo.paperId
        // }
        if (this.courseInfo.paperId && (this.bizType === 1 || this.bizType === 3)) {
          d.paperId = this.courseInfo.paperId
        }
        userFaceId(d).then((res) => {
          if (res.code === 200) {
            this.openWin(res.data)
          } else {
            this.signData.signFailNum++
            this.reset(res.msg)
          }
        })
      })
    },
    getRecordingData (e) { // 保存摄像内容
      this.chunks.push(e.data)
    },
    saveRecordingData () { // 格式化视频内容 并上传视频
      const blob = new Blob(this.chunks, { type: 'video/webm' })
      const videoStream = URL.createObjectURL(blob)
      this.videoStream = { stream: videoStream, Blob: blob }
      this.chunks = []
      this.uploadVideo()
    },
    openCamera () {
      this.signStatus = 1
      const This = this
      this.startBtnText = '检测摄像头中...'
      // 判断有没有摄像头获取函数没有 添加一个
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          const getUserMedia =
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia ||
            navigator.oGetUserMedia
          if (!getUserMedia) {
            return Promise.reject(
              new Error('getUserMedia is not implemented in this browser')
            )
          }
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }

      const video = document.getElementById('FaceIdVideo')// 显示摄像头拍摄的内容
      const tracker = new window.tracking.ObjectTracker('face') // 引入人脸第三方库
      video.src = ''
      this.FaceIdVideo = video
      tracker.setInitialScale(1)
      tracker.setStepSize(2)
      tracker.setEdgesDensity(0.1)
      this.trackerTask = window.tracking.track('#FaceIdVideo', tracker, {
        camera: true
      })
      const constraints = {
        video: { width: 688, height: 387, facingMode: 'user' },
        audio: false
      }
      const that = this
      this.promise = navigator.mediaDevices.getUserMedia(constraints) // h5 新的API
      this.promise.then((MediaStream) => {
        this.isUnion = true
        this.startBtnText = '正在验证中，请勿离开此页...'
        video.srcObject = MediaStream
        this.localStream = MediaStream
        this.recorder = new window.MediaRecorder(MediaStream)
        this.recorder.ondataavailable = this.getRecordingData // 设置视频缓存到内存
        this.recorder.onstop = this.saveRecordingData// 视频录像结束上传函数
        video.play()
        setTimeout(() => {
          this.loading = false
        }, 100)

        this.countdown = this.signData.signWaitTime || 10 // 倒计时10秒后没有识别到人脸就默认打卡失败
        this.timer = setInterval((res) => {
          this.countdown--
          if (this.countdown === -1) { // 超时了
            clearInterval(this.timer)
            this.reset('人脸识别超时！')
          }
        }, 1000)
        that.tracker_fun(tracker) // open 摄像头，执行tracker_fun( 传入参数 )
      }).catch((err) => {
        console.error(err)
        This.startBtnText = '摄像头异常...'
        ElMessageBox.alert('请确认一下是否有摄像头或者是否点击同意授权网站使用摄像头？若没有摄像头，请登录小程序或者APP进行人脸识别？', '错误提示', {
          confirmButtonText: '重新登录授权摄像头',
          cancelButtonText: '返回首页',
          callback: (action) => {
            if (action !== 'cancel') {
            // 清除所有cookie函数
              const keys = document.cookie.match(/[^ =;]+(?==)/g)
              if (keys) {
                for (let i = keys.length; i--;) {
                  document.cookie =
                    keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
                  document.cookie =
                    keys[i] +
                    '=0;path=/;domain=' +
                    document.domain +
                    ';expires=' +
                    new Date(0).toUTCString() // 清除当前域名下的，例如 .m.ratingdog.cn
                  document.cookie =
                    keys[i] +
                    '=0;path=/;domain=ratingdog.cn;expires=' +
                    new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .ratingdog.cn
                }
              }
            } else {
              this.hideSign()
              this.startBtnText = '开始验证'
              this.signStatus = 0
            }
          }
        })
      })
    },
    tracker_fun (tracker) {
      const that = this
      // 每秒 检测人脸 结果
      tracker.on('track', (event) => {
        // 视频流
        // if  --- > else  检测到人脸 success() =>{}
        event.data.forEach((rect) => {
          if (rect.x) {
            clearInterval(this.timer)
            that.plot = {
              left: rect.x + 'px',
              top: rect.y + 'px',
              width: rect.width + 'px',
              height: rect.height + 'px',
              opacity: 1
            }
            if (!that.first) {
              that.first = rect.x
              that.onStart()
            }
          } else {
            that.plot.opacity = 0
          }
        })
      })
    },
    clickSign () {
      this.loading = true
      const d = {
        bizType: this.bizType || 2,
        checkType: this.signType || 2,
        courseId: this.courseInfo.id,
        _No_dispose: true
      }

      if (this.courseInfo.chapterId) {
        d.chapterId = this.courseInfo.chapterId
      }
      if (this.courseInfo.periodId) {
        d.periodId = this.courseInfo.periodId
      }
      userFaceId(d).then((res) => {
        this.loading = false
        if (res.code === 200) {
          this.openWin(res.data)
        } else {
          this.reset(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss">
.course-sign-dialog {
  border-radius:  6px ;
  overflow: hidden;
  max-height: 100vh;
  .el-dialog__body {
    overflow: hidden;
    padding-bottom: 14px;
  }
}
</style>
<style scoped lang="scss">
.box {
  min-height: 248px;
  padding-top: 18px;
  .circle-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 4px;
    width: 150px;
    height: 150px;
    margin: auto;
    background: #3D7FFF;
    box-shadow: 0px 4px 14px rgba(61, 127, 255, 0.38);
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    .click-time {
      opacity: 0.6;
    }
  }
  .click-tip {
    margin-top: 24px;
    text-align: center;
  }
}
.video-box {
  position: relative;
  text-align: center;
  margin-top: -14px;
  padding-bottom: 8px;
  .sign-video {
    border-radius: 5px;
    position: relative;
    height: 387px;
    overflow: hidden;
    background: url('@/assets/sgin.png') center no-repeat;
    background-size:  auto 100%;
    image-rendering:-moz-crisp-edges;
    image-rendering:-o-crisp-edges;
    image-rendering:-webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode:nearest-neighbor;
  }

  .union {
    position: absolute;
    bottom: -60px;
    z-index: 100;
    width: 468px;
    left: 110px;
  }
  #FaceIdVideo {
    height: 387px;
    width: 688px;
    position: relative;
    z-index: 10;
  }
  .signImg{
    height: 390px;
    width: 570px;
    display: none;
    position: absolute;
    z-index: 12;
    top: 0px;
    left: 0px;
  }
  .countdown {
    width: 85px;
    position: absolute;
    right: 6px;
    top: 348px;
    height: 36px;
    border-radius: 5px;
    line-height: 36px;
    font-size: 14px;
    color: #FFFFFF;
    z-index: 20;
    background: rgba(51, 51, 51, 0.5);

  }

  .plot {
    position: absolute;
    z-index: 100;

    border: 2px solid #67c23a;
  }

  .btn-list {
    display: flex;
    margin-top: 40px;
    .btn {
      width: 154px;
      font-weight: 400;
      font-size: 14px;
      height: 42px;
    }
    .max-btn {
      flex: 1;
      font-weight: 400;
      font-size: 14px;
      height: 42px;
    }
  }

  .video-tip {
    z-index: 101;
    box-sizing: border-box;
    text-align: center;
    width: 100%;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    margin-top: 10px;
    border-radius: 5px;
    background: #eee;

    &.red {
      background: rgba(213, 20, 35, 0.1);
      .video-tip-text {
        color: #D51423
      }
    }
    .video-tip-text {
      color: #333;
    }
  }

  .reset-box {
    position: absolute;
    top: -1px;
    left: 0;
    width: 688px;
    height: 389px;
    padding-top: 82px;
    border-radius: 5px;
    background:#fff;
    z-index: 101;
    box-sizing: border-box;
    text-align: center;
    .iconfont {
      color:#FF4844;
      margin: 10px 0 0px;
      font-size: 93px;
    }
    .reset-title {
      font-weight: 500;
      font-size: 22px;
      margin-top: -20px;
      line-height: 28px;
      color: #333333;
    }

    .reset-tip {
      font-weight: 500;
      font-size: 22px;
      margin-top: 4px;
      line-height: 28px;
      color: #333333;
    }
  }

  .win-box {
    position: absolute;
    top: -1px;
    left: 0;
    width: 688px;
    height: 389px;
    padding-top: 110px;
    border-radius: 5px;
    background: #fff;
    z-index: 101;
    box-sizing: border-box;
    text-align: center;
    &.win-box-click {
      padding-top: 20px;
      width: 100%;
      height: 100%;
    }

    .iconfont {
      color: #19CF8A;
      margin: 10px 0 0px;
      font-size: 90px;
    }
    .win-title {
      font-weight: 500;
      font-size: 22px;
      margin-top: -12px;
      line-height: 28px;
      color: #333333;
    }
    .win-tip-text {
      font-size: 12px;
      margin-top: 14px;
      line-height: 16px;
      color: #999999;
      span {
        color: #19CF8A;
        margin-right: 6px;;
      }
    }
  }
}

.sign-tip, .signuserFaceId-tip {
  text-align: left;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #999999;

  .red {
    color:red;
    font-size: 16px;
    margin: 0 4px;
  }
}

</style>
